"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkHelpers = exports.getDisplayAttributes = exports.blankImageUrl = void 0;
const pixel_ratio_1 = __importDefault(require("@padlet/pixel-ratio"));
const display_1 = require("./display");
const blank_image_1 = __importDefault(require("./blank_image"));
exports.blankImageUrl = blank_image_1.default;
const LinkHelpers = __importStar(require("./link_helpers"));
exports.LinkHelpers = LinkHelpers;
const cache = {};
function fetchFromCache(query) {
  const cachedAttrs = cache[JSON.stringify(query)];
  if (!cachedAttrs) {
    return null;
  }
  return cachedAttrs;
}
function addToCache(query, attrs) {
  cache[JSON.stringify(query)] = attrs;
}
async function getDisplayAttributes(link, options) {
  const query = Object.assign({
    url: link.url,
    width: 500,
    locale: 'en',
    dpr: pixel_ratio_1.default
  }, options);
  let displayAttrs = fetchFromCache(query);
  if (!displayAttrs) {
    displayAttrs = (0, display_1.buildDisplayAttributesFromLink)(link, query);
    addToCache(query, displayAttrs);
  }
  return displayAttrs;
}
exports.getDisplayAttributes = getDisplayAttributes;